module.exports = __webpack_public_path__ + "static/media/Artboard6.34fb5902.png";